import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Box from '@mui/material/Box'
import { useState } from 'react'
import { useIntl } from 'react-intl'
import TabManagemment from './TabManagement'
import SplashScreen from './SplashScreen'
import TabCashRegisterManagement from './TabCashRegisterManagement'
import TabBilling from './TabBilling'
import TabPreQuotation from './TabPreQuotation'
interface TabPanelProps {
  children?: React.ReactNode
  index: number
  value: number
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index } = props

  return (
    <Box sx={{ height: '100%' }}>
      {value === index && (
        <Box sx={{ paddingLeft: 1, paddingRight: 2, height: '87vh' }}>
          {children}
        </Box>
      )}
    </Box>
  )
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  }
}

const myTabsProps = [
  // {
  //   labelTab: 'Tableau de Bord',
  //   icon: 'fas fa-file-invoice-dollar',
  //   title: '123',
  //   render: 'SplashScreen',
  // },
  {
    labelTab: 'Administration',
    icon: 'fas fa-file-invoice-dollar',
    title: '123',
    render: 'TabManagemment',
  },
  {
    labelTab: 'Suivi de facturation',
    icon: 'fas fa-file-invoice-dollar',
    title: '123',
    render: 'TabBilling',
  },
  {
    labelTab: 'Gestion des caisses',
    icon: 'fas fa-file-invoice-dollar',
    title: '123',
    render: 'TabCashregisterManagement',
  },
  {
    labelTab: 'Relance',
    icon: 'fas fa-file-invoice-dollar',
    title: '123',
    render: null,
  },
  {
    labelTab: 'Suivie FSE',
    icon: 'fas fa-file-invoice-dollar',
    title: '123',
    render: null,
  },
  {
    labelTab: 'Pré-cotation',
    icon: 'fas fa-file-invoice-dollar',
    title: '123',
    render: 'TabPreQuotation',
  },
]

export default function Worklists() {
  const [value, setValue] = useState(0)

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue)
  }

  return (
    <Box>
      <Box
        sx={{
          marginTop: '5px',
        }}
      >
        <Tabs
          indicatorColor="primary"
          textColor="primary"
          value={value}
          onChange={handleChange}
          aria-label="exams-tabs"
          sx={{
            marginLeft: 1,
            marginBottom: '-22px',
            paddingBottom: '2px',
          }}
        >
          {myTabsProps.map((el, index) => {
            return (
              <Tab
                label={el.labelTab}
                {...a11yProps(0)}
                sx={{
                  backgroundColor: '#fff',
                  borderRadius: '5px 5px 0px 0px',
                  marginRight: '8px',
                }}
                key={index}
              />
            )
          })}
        </Tabs>
      </Box>

      {myTabsProps.map((el, index) => {
        return (
          <TabPanel value={value} index={index} key={index}>
            {/* {el.render === 'SplashScreen' ? (
              <SplashScreen />
            ) : */}
            {el.render === 'TabManagemment' ? (
              <TabManagemment />
            ) : el.render === 'TabBilling' ? (
              <TabBilling dataTabs={el} />
            ) : el.render === 'TabPreQuotation' ? (
              <TabPreQuotation dataTabs={el} />
            ) : el.render === 'TabCashregisterManagement' ? (
              <TabCashRegisterManagement dataTabs={el} />
            ) : (
              <></>
            )}
          </TabPanel>
        )
      })}
    </Box>
  )
}
